import { render, staticRenderFns } from "./FedExSuccessStep.vue?vue&type=template&id=f0cb9a80&scoped=true"
import script from "./FedExSuccessStep.vue?vue&type=script&lang=ts"
export * from "./FedExSuccessStep.vue?vue&type=script&lang=ts"
import style0 from "./FedExSuccessStep.vue?vue&type=style&index=0&id=f0cb9a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cb9a80",
  null
  
)

export default component.exports